import { render, staticRenderFns } from "./AppFormAnnualTax.vue?vue&type=template&id=6e474547"
import script from "./AppFormAnnualTax.vue?vue&type=script&lang=js"
export * from "./AppFormAnnualTax.vue?vue&type=script&lang=js"
import style0 from "./AppFormAnnualTax.vue?vue&type=style&index=0&id=6e474547&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports